// 法语(French)
export default {
  coinSpecialOffer: "Offre spéciale de recharge de pièces HT",
  buySomeAndGetExtra: "Achetez-en et obtenez-en plus !",
  balance: "Solde",
  coins: "{number} pièces",
  coin: "{number} pièce",
  extraCoins: "{number} pièces bonus",
  continue: "Continuer",
  byToppingUpYouAgree: "En rechargeant, vous acceptez l'accord",
  topUpAgreement: "[Accord complémentaire]",
  htCoin: "Jeton HT",
  scanCodeToLog: "Scannez le code pour vous connecter",
  bindYourHelloTalkAccount:
    "Utilisez l'application HelloTalk pour scanner le code et vous connecter. Liez votre compte HelloTalk et rechargez.",
  itemSelection: "Sélection d'articles",
  paymentAmount: "Montant",
  topUpSuccessful: "Recharge réussie👏",
  totalCoinsNumber:
    "Vous avez ajouté avec succès {numberone} pièces et reçu {numbertwo} pièces supplémentaires, pour un total de {numberall} pièces.",
  ok: "OK",
  copyLinkToPay:
    "Veuillez copier le lien et l'ouvrir avec l'application HelloTalk pour effectuer le paiement.",
  paymentFailed: "Échec du paiement",
  creditCardPay: "Payez avec PayPal ou avec une carte de crédit",
  creditCard: "Carte de crédit",
};
